const Warning = () => {
  return (
    <svg viewBox="0 0 24 24" fill="none">
      <path
        d="M12 9V13M12 17H12.01M10.29 3.86L1.82 18C1.64 18.31 1.55 18.66 1.55 19.01C1.55 20.11 2.44 21 3.54 21H20.46C21.56 21 22.45 20.11 22.45 19.01C22.45 18.66 22.36 18.31 22.18 18L13.71 3.86C13.52 3.55 13.28 3.29 12.99 3.1C12.06 2.48 10.82 2.74 10.29 3.86Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default Warning